import axios, { AxiosError } from 'axios';
import type { DefaultGetResponse } from '~/App/Api/rest';
import {
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions,
} from 'react-query';
import { GuideProgressType, Service } from '~/types/models';

export const queryKeys = {
  all: ['guide-progress'],
  details: () => [...queryKeys.all, 'detail'] as const,
  service: (service: Service) => [...queryKeys.details(), service] as const,
};

const apiUrl = '/api/v3/guide';

export const getGuideProgress = async (service: Service) => {
  const response = await axios.get<GuideProgressType[]>(
    `${apiUrl}/${service}/progress`
  );

  return response.data;
};

export interface UseGuideProgressHookParams {
  service: Service;
  options?: UseQueryOptions<GuideProgressType[], AxiosError>;
}

export const useGuideProgress = ({
  service,
  options,
}: UseGuideProgressHookParams) =>
  useQuery<DefaultGetResponse<GuideProgressType[]>, AxiosError>(
    queryKeys.service(service),
    () => getGuideProgress(service),
    options
  );

export interface UpdateGuideProgressArgs {
  service: Service;
  type: GuideProgressType;
}

export const updateGuideProgress = async ({
  service,
  type,
}: UpdateGuideProgressArgs) => {
  const response = await axios.put<string>(`${apiUrl}/tick`, { service, type });

  return response.data;
};

export interface UseUpdateGuideProgressHookParams {
  options?: UseMutationOptions<string, AxiosError, UpdateGuideProgressArgs>;
}

export const useUpdateGuideProgress = ({
  options,
}: UseUpdateGuideProgressHookParams) => {
  return useMutation(updateGuideProgress, options);
};
